const state = {
  userMails: [],
  error: 0
}

const getters = {
  userMails: state => state.userMails
}

const actions = {
  getUserMails ({ commit }, payload) {
    commit('setUserMails', payload)
  }
}

const mutations = {
  setUserMails (state, all) {
    state.userMails = all.data.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
